<template>
  <div>
    <div class="row">
      <div class="col-sm-12">
        <OnFssDiff :fss=fss :rliss="rliss" ></OnFssDiff>
      </div>
    </div>
  </div>
</template>

<script>
import OnFssDiff from '@/components/OnFssDiff.vue'
import axios from 'axios';

export default {
  data: function() {return {
    fss: [],
    rliss: []
  }},

  name: 'OnCompletion',
  components: {
    OnFssDiff,
  },
  methods: {
    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/on/completion.php',
          { })
        .then(response => {
          this.fss = response.data.fss;
          this.rliss = response.data.rliss;
        })
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>
